var path = 'common/services/session/sessionModalWindow.tpl.html';
var html = "<div class=\"modal-dialog session-modal\" ng-class=\"size ? 'modal-' + size : ''\"> <div class=\"modal-content give-modal-content\" uib-modal-transclude></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;